import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { accordionAnatomy } from '@chakra-ui/anatomy';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const trackAccordion = definePartsStyle({
  button: {
    bgColor: 'red',
  },
  root: {
    borderTop: '2px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
  },
  container: {
    borderRadius: '8px',
  },
});

const entryAccordion = definePartsStyle({
  root: {
    border: '1.5px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
  },
  container: {
    borderRadius: '8px',
  },
});

const videoAccordion = definePartsStyle({
  root: {
    border: '1.5px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
  },
});

const statsAccordion = definePartsStyle({
  root: {
    border: { base: 'none', md: '1.5px solid rgba(255, 255, 255, 0.1)' },
    borderRadius: '4px',
    background: {
      base: 'darkVoid.100',
      md: 'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%)',
    },
    backgroundOrigin: 'border-box',
  },
});

export const accordionTheme = defineMultiStyleConfig({
  variants: { trackAccordion, entryAccordion, videoAccordion, statsAccordion },
  defaultProps: {
    variant: 'trackAccordion',
  },
});
